import { createContext, Context } from 'react';

const AppContext: Context<any> = createContext(null);

export { AppContext };
